import { useContext } from "react"

import { AuthContext } from "../providers/auth_provider"

function useAuth() {
  return useContext(AuthContext)
}

export default useAuth
